import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=3c2c1f86&scoped=true"
import script from "./Administracion.vue?vue&type=script&lang=js"
export * from "./Administracion.vue?vue&type=script&lang=js"
import style0 from "./Administracion.vue?vue&type=style&index=0&id=3c2c1f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c1f86",
  null
  
)

export default component.exports